import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Icon } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import styles from './index.css'

const TYPE_ICONS = [
  { icon: 'file alternate', regExp: /\.(txt|tex|log)$/ },
  { icon: 'file archive', regExp: /\.(zip|7z|pkg|tar|gz|tgz|z)$/ },
  { icon: 'file audio', regExp: /\.(wav|aif|mp3|mpa|ogg)$/ },
  { icon: 'file code', regExp: /\.(x?html?|MHTM?L?|xml|css|js|rss)$/ },
  { icon: 'file excel', regExp: /\.(xlsx?|xlsm|csv|ods|xlc)$/ },
  { icon: 'file image', regExp: /\.(png|bmp|jpe?g|gif|ai|svg|psd|tiff?)$/ },
  { icon: 'file pdf', regExp: /\.(pdf)$/ },
  { icon: 'file powerpoint', regExp: /\.(pptx?|key|odp|pps)$/ },
  { icon: 'file video', regExp: /\.(mp4|3g2|3gp|avi|flv|h264|m4v|mkv|mov|mpe?g|vid)$/ },
  { icon: 'file word', regExp: /\.(docx?|rtf|odt|wpd)$/ },
]

class FileLink extends PureComponent {
  getHumanSize = () => {
    let unit = 'B'
    let amount = this.props.size

    if (amount >= 1024) {
      unit = 'KB'
      amount /= 1024
    }

    if (amount >= 1024) {
      unit = 'MB'
      amount /= 1024
    }

    if (amount >= 1024) {
      unit = 'GB'
      amount /= 1024
    }

    return (
      <i className={styles.size}>
        {+amount.toFixed(2)}
        <b>{unit}</b>
      </i>
    )
  }

  onClick = (e) => {
    if (!this.props.href) {
      e.preventDefault()
    }
  }

  renderIcon() {
    const { loading, name } = this.props
    const icon = TYPE_ICONS.find((i) => name.match(i.regExp))?.icon || 'file'

    return (
      <Icon
        aria-hidden="true"
        className={styles.icon}
        loading={loading}
        name={loading ? 'spinner' : `${icon} outline`}
      />
    )
  }

  render() {
    const { className, href, name, size } = this.props
    return (
      <a
        className={cn(className, styles.link, !href && styles.disabled)}
        download={name}
        href={href}
        onClick={this.onClick}
        rel="noopener noreferrer"
        tabIndex={href ? 0 : -1}
        target="_blank"
        title={name}
      >
        {this.renderIcon()}
        <span className={styles.text}>{name}</span>
        {!!size && this.getHumanSize()}
      </a>
    )
  }
}

FileLink.propTypes = {
  name: PropTypes.string.isRequired,

  className: PropTypes.string,
  href: PropTypes.string,
  loading: PropTypes.bool,
  size: PropTypes.number,
}

FileLink.defaultProps = {
  className: '',
  href: '',
  loading: false,
  size: 0,
}

export default FileLink
